export function decodeBrackets(encodedQueryString: string): string {
  return encodedQueryString.replace(/%5B/g, '[').replace(/%5D/g, ']')
}
